<template>
  <div>
    <el-upload
      ref="upload"
      class="upload-demo"
      :action="uploadImgUrl"
      :headers="headers"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :on-remove="handleRemove"
      :on-error="handleUploadError"
      multiple
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="accept"
      :data="{ code }"
    >
      <div class="flex-center">
        <el-button size="medium" type="text" icon="el-icon-paperclip">{{ btnText }}</el-button>
        <span v-if="!desc" class="font-12 color-666">
          （单个附件不超过{{ fileSize }}M，最多可上传{{ limit }}个）
        </span>
        <span v-else class="font-12 color-666 margin-left-15 color-redFont">{{ desc }}</span>
      </div>
    </el-upload>
  </div>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  export default {
    props: {
      // 文件数量限制
      limit: {
        type: Number,
        default: 5
      },
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 5
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },
      list: {
        type: Array,
        default: () => []
      },
      btnText: {
        type: String,
        default: '上传附件'
      },
      accept: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      code: {
        type: String,
        default: 'unknown'
      }
    },
    data() {
      return {
        number: 0,
        uploadImgUrl: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        fileList: [],
        uploadList: []
        // fileName: ''
      }
    },
    watch: {
      list: {
        handler(newValue, oldValue) {
          this.fileList = newValue || []
        },
        immediate: true
      }
    },
    // mounted() {
    //   this.fileList = this.list
    // },
    methods: {
      // 上传前loading加载
      handleBeforeUpload(file) {
        return new Promise((resolve, reject) => {
          if (file.name && file.name.length > 80) {
            this.$message.error('文件名称不能超过80字!')
            reject(new Error('文件名称不能超过80字！'))
            return
          }

          const isLt = file.size / 1024 / 1024 < (this.fileSize || 5)
          if (!isLt) {
            this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`)
            reject(new Error(`上传文件大小不能超过 ${this.fileSize} MB!`))
            return
          }

          // 文件类型验证
          if (this.accept && !this.validateFileType(file)) {
            const acceptTypes = this.accept.split(',').join('、')
            this.$message.error(`请上传后缀为${acceptTypes}的文件`)
            reject(new Error('不支持的文件格式'))
            return
          }

          this.number++
          resolve(file)
        })
      },

      // 验证文件类型
      validateFileType(file) {
        if (!this.accept) return true

        const acceptTypes = this.accept.split(',').map((type) => type.trim().toLowerCase())
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
        const fileType = file.type.toLowerCase()

        // 检查文件扩展名或MIME类型是否匹配
        return acceptTypes.some((acceptType) => {
          // 处理通配符，如 image/*
          if (acceptType.endsWith('/*')) {
            const baseType = acceptType.replace('/*', '')
            return fileType.startsWith(baseType + '/')
          }

          // 处理具体扩展名，如 .jpg
          if (acceptType.startsWith('.')) {
            return fileExtension === acceptType.toLowerCase()
          }

          // 处理MIME类型，如 image/jpeg
          return fileType === acceptType.toLowerCase()
        })
      },
      // 删除
      handleRemove(file, fileList) {
        const findex = this.fileList.map((f) => f.name).indexOf(file.name)
        if (findex > -1) {
          this.fileList.splice(findex, 1)
          this.$emit('input', this.fileList)
        }
      },
      // 上传失败
      handleUploadError(res) {
        this.$message.error('上传文件失败，请重试')
      },
      // 上传成功回调
      handleUploadSuccess(res, file) {
        console.log(this.$refs.upload)
        if (!res.data) {
          this.$message.error(res.msg || '上传文件失败，请重试')
          this.$refs.upload.uploadFiles.splice(this.$refs.upload.uploadFiles.indexOf(file), 1)
          return
        }

        this.uploadList.push({
          name: res.data.name,
          url: res.data.url
        })
        if (this.uploadList.length === this.number) {
          this.fileList = this.fileList.concat(this.uploadList)
          this.uploadList = []
          this.number = 0
          // this.$emit('input', this.fileList)
        }
        this.$emit('input', this.fileList)
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
      },
      // 清除列表
      clearList() {
        this.$refs.upload.clearFiles()
      }
      // 对象转成指定字符串分隔
      // listToString(list, separator) {
      //   let strs = "";
      //   separator = separator || ",";
      //   for (let i in list) {
      //     strs += list[i].url.replace(this.baseUrl, "") + separator;
      //   }
      //   return strs != '' ? strs.substr(0, strs.length - 1) : '';
      // }
    }
  }
</script>

<style lang="scss" scoped></style>
